module.exports = __webpack_public_path__ + "img/temperature-tag.8320e3c7.png";